var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeutral(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4791_871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25Z",
    fill: "#FFCA28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 10.9375C8.67545 10.9375 9.375 10.2379 9.375 9.375C9.375 8.51206 8.67545 7.8125 7.8125 7.8125C6.94956 7.8125 6.25 8.51206 6.25 9.375C6.25 10.2379 6.94956 10.9375 7.8125 10.9375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 10.9375C18.0504 10.9375 18.75 10.2379 18.75 9.375C18.75 8.51206 18.0504 7.8125 17.1875 7.8125C16.3246 7.8125 15.625 8.51206 15.625 9.375C15.625 10.2379 16.3246 10.9375 17.1875 10.9375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4062 18.75H8.59375C8.1625 18.75 7.8125 18.4 7.8125 17.9688C7.8125 17.5375 8.1625 17.1875 8.59375 17.1875H16.4062C16.8375 17.1875 17.1875 17.5375 17.1875 17.9688C17.1875 18.4 16.8375 18.75 16.4062 18.75Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4791_871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutral);
export default __webpack_public_path__ + "static/media/neutral.55703e9eaad873d3865686650a568f62.svg";
export { ForwardRef as ReactComponent };